<template>
    <div class="max-w-lg mx-auto py-16 px-4 text-center">
        <div class="mb-6">
            <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <h1 class="text-2xl font-bold text-gray-900 mb-2">Assinatura confirmada!</h1>
            <p class="text-gray-500 text-sm">Obrigado por assinar o Sirimmatrix.</p>
            <p class="text-gray-400 text-xs mt-2">
                <span v-if="confirming" class="loading loading-spinner loading-xs mr-1"></span>
                {{ confirming ? 'Liberando seu acesso...' : 'Seu acesso está ativo.' }}
            </p>
        </div>
        <button class="btn btn-primary text-white" :disabled="confirming" @click="goHome">Ir para a plataforma</button>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import AuthService from '@/services/AuthService';

const ACTIVE_STATUSES = ['active', 'past_due', 'trial'];
const POLL_INTERVAL_MS = 1500;
const MAX_ATTEMPTS = 10;

export default {
    setup() {
        const router = useRouter();
        const confirming = ref(true);

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }

        // O webhook do Stripe que ativa a assinatura no nosso banco pode levar
        // alguns segundos pra chegar — sem isso, o usuário volta pra plataforma
        // com o token antigo e continua vendo "teste encerrado".
        async function waitForActiveSubscription() {
            for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
                try {
                    await AuthService.refreshSession();
                    const auth = AuthService.getAuthInfo();
                    if (auth && ACTIVE_STATUSES.includes(auth.subscription_status)) {
                        return true;
                    }
                } catch (e) { /* tenta de novo */ }
                await sleep(POLL_INTERVAL_MS);
            }
            return false;
        }

        onMounted(async () => {
            await waitForActiveSubscription();
            confirming.value = false;
            setTimeout(() => router.push({ name: 'home' }), 1500);
        });

        function goHome() {
            router.push({ name: 'home' });
        }

        return { confirming, goHome };
    }
};
</script>
